export default {
  "placeholder": "_placeholder_mjyio3",
  "left-items-container": "_left-items-container_mjyio3",
  "clear-btn": "_clear-btn_mjyio3"
};